const ft2Initialized = new WeakMap();

function ft2InitProducts(root) {
  const controller = new AbortController();
  root.addEventListener('change', (event) => {
    const select = event.target.closest('[data-ft2-variant]');
    if (!select) return;
    const option = select.selectedOptions[0];
    const card = select.closest('[data-ft2-card]');
    const button = card.querySelector('[data-ft2-add]');
    const error = card.querySelector('.js-form-error');
    if (!option || !button) return;
    card.querySelector('[data-ft2-price]').textContent = option.dataset.price;
    const compare = card.querySelector('[data-ft2-compare]');
    compare.textContent = option.dataset.compare || '';
    compare.hidden = !option.dataset.compare;
    button.disabled = option.dataset.available !== 'true';
    button.textContent = button.disabled ? button.dataset.ft2SoldOut : button.dataset.ft2Add;
    card.querySelector('[data-ft2-quantity]').value = option.dataset.quantity || '1';
    if (error) { error.hidden = true; error.textContent = ''; }
    card.querySelectorAll('[data-ft2-product-link]').forEach(link => {
      const url = new URL(link.href, location.origin);
      url.searchParams.set('variant', option.value);
      link.href = url.href;
    });
    const image = card.querySelector('[data-ft2-card-image]');
    if (card.dataset.variantImages === 'true' && option.dataset.image && image) {
      image.removeAttribute('srcset');
      image.src = option.dataset.image;
      card.querySelector('.ft2-card__media').classList.add('ft2-card__media--catalog');
    }
  }, { signal: controller.signal });
  return () => controller.abort();
}

function ft2InitReviews(root) {
  const track = root.querySelector('[data-ft2-review-track]');
  const controls = root.querySelector('[data-ft2-review-controls]');
  if (!track || !controls) return () => {};
  const controller = new AbortController();
  const signal = controller.signal;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const previous = root.querySelector('[data-ft2-prev]');
  const next = root.querySelector('[data-ft2-next]');
  const pause = root.querySelector('[data-ft2-pause]');
  let paused = false;
  let visible = true;
  let timer;
  const end = () => Math.max(0, track.scrollWidth - track.clientWidth);
  const overflow = () => end() > 2;
  const update = () => {
    controls.hidden = !overflow();
    previous.disabled = !overflow();
    next.disabled = !overflow();
    if (pause) {
      const effectivelyPaused = paused || motion.matches;
      pause.setAttribute('aria-pressed', String(effectivelyPaused));
      pause.textContent = effectivelyPaused ? pause.dataset.playLabel : pause.dataset.pauseLabel;
    }
  };
  const move = (direction) => {
    const first = track.firstElementChild;
    if (!first || !overflow()) return;
    const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
    const current = Math.abs(track.scrollLeft);
    const target = direction > 0 ? (current >= end() - 2 ? 0 : Math.min(current + step, end())) : (current <= 2 ? end() : Math.max(0, current - step));
    track.scrollTo({ left: getComputedStyle(track).direction === 'rtl' ? -target : target, behavior: motion.matches ? 'instant' : 'smooth' });
  };
  const stop = () => { clearInterval(timer); timer = undefined; };
  const start = () => {
    stop(); update();
    if (root.dataset.autoplay !== 'true' || motion.matches || paused || !visible || document.hidden || !overflow() || root.matches(':hover,:focus-within')) return;
    timer = setInterval(() => move(1), Math.max(5000, Number(root.dataset.interval) || 6000));
  };
  previous.addEventListener('click', () => move(-1), { signal });
  next.addEventListener('click', () => move(1), { signal });
  pause?.addEventListener('click', () => { paused = !paused; start(); }, { signal });
  root.addEventListener('pointerenter', stop, { signal });
  root.addEventListener('pointerleave', start, { signal });
  root.addEventListener('focusin', stop, { signal });
  root.addEventListener('focusout', () => requestAnimationFrame(start), { signal });
  document.addEventListener('visibilitychange', start, { signal });
  motion.addEventListener('change', start, { signal });
  const resize = new ResizeObserver(start);
  resize.observe(track);
  const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; start(); }, { threshold: 0.2 });
  observer.observe(root);
  start();
  return () => { stop(); controller.abort(); resize.disconnect(); observer.disconnect(); };
}

function ft2InitSticky(root) {
  const hero = document.querySelector('[data-ft2-hero]');
  if (!hero || !('IntersectionObserver' in window)) return () => {};
  const observer = new IntersectionObserver(entries => {
    const entry = entries[0];
    root.dataset.visible = String(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
  });
  observer.observe(hero);
  return () => observer.disconnect();
}

function ft2Initialize(scope = document) {
  for (const [selector, initialize] of [['[data-ft2-products]', ft2InitProducts], ['[data-ft2-reviews]', ft2InitReviews], ['[data-ft2-sticky]', ft2InitSticky]]) {
    const matches = [...scope.querySelectorAll(selector)];
    if (scope.matches?.(selector)) matches.unshift(scope);
    matches.forEach(root => {
      if (!ft2Initialized.has(root)) ft2Initialized.set(root, initialize(root));
    });
  }
}

ft2Initialize();
document.addEventListener('shopify:section:load', event => {
  ft2Initialize(event.target);
  document.querySelectorAll('[data-ft2-sticky]').forEach(root => {
    ft2Initialized.get(root)?.();
    ft2Initialized.delete(root);
    ft2Initialized.set(root, ft2InitSticky(root));
  });
});
document.addEventListener('shopify:section:unload', event => {
  event.target.querySelectorAll('[data-ft2-products],[data-ft2-reviews],[data-ft2-sticky]').forEach(root => {
    ft2Initialized.get(root)?.();
    ft2Initialized.delete(root);
  });
});
